import { Pagination } from "../../../components/Pagination";
import { LongSentenceAchievementEntity } from "../../../types";
import { LongSentenceResultListRow } from "./LongSentenceResultListRow";

type Props = {
  longSentenceAchievements: LongSentenceAchievementEntity[];
  onePageDisplayItems: number;
  itemSize: number;
  handleGetLongSentenceAchievements: (page: number) => void;
};

export const LongSentenceResultList = (props: Props) => {
  const listRows = props.longSentenceAchievements.map(
    (value: LongSentenceAchievementEntity, index: number) => (
      <LongSentenceResultListRow key={index} longSentenceAchievement={value} />
    )
  );

  const pageCount = Math.ceil(props.itemSize / props.onePageDisplayItems);

  return (
    <div className="relative">
      <div className="bg-white rounded-xl px-10 py-5 mx-10">
        {pageCount > 1 ? (
          <div className="flex flex-row-reverse pb-3">
            <Pagination
              pageCount={pageCount}
              handleGetItem={props.handleGetLongSentenceAchievements}
            />
          </div>
        ) : (
          <div className="pb-3"></div>
        )}
        <div className="overflow-x-scroll">
          <table className="w-full border-collapse whitespace-nowrap">
            <thead>
              <tr>
                <th className="h-16 px-5 leading-tight font-bold bg-blue text-white border-r border-white relative">
                  Lv
                </th>
                <th className="h-16 px-5 leading-tight font-bold bg-blue text-white border-r border-white">
                  カテゴリ
                </th>
                <th className="h-16 px-5 leading-tight font-bold bg-blue text-white border-r border-white">
                  タイトル
                </th>
                <th className="h-16 px-5 leading-tight font-bold bg-blue text-white border-r border-white">
                  再生
                </th>
                <th className="h-16 px-5 leading-tight font-bold bg-blue text-white border-r border-white">
                  開始日時
                </th>
                <th className="h-16 px-5 leading-tight font-bold bg-blue text-white border-r border-white">
                  回数
                </th>
                <th className="h-16 px-5 leading-tight font-bold bg-blue text-white">
                  スピーキング結果
                </th>
              </tr>
            </thead>
            <tbody>{listRows}</tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
